function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @file 使模块可配置化
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/configurable
 */
import { extend, camelToUnder } from './json';
/**
 * 使函数支持配置化
 *
 * @function configurable
 * @param {Function} fn 需要可配置化的函数
 * @param {?Object=} [defaults={}] 默认配置值
 * @return {Function} 包装后支持可配置化的函数
 */

export default (function (fn) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var config = _objectSpread({}, defaults);

  var mod = function mod(json) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, [extend({}, config, camelToUnder(json))].concat(args));
  };

  mod.setConfig = function () {
    var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return extend(config, camelToUnder(defaults));
  };

  return mod;
});